import React from "react";
import PropTypes from "prop-types";
import { Card, CardActions, CardContent, Divider, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

export default function BaseEventCard({
  accentColor,
  title,
  chips,
  info,
  body,
  primaryAction,
  managementActions,
  showManagement,
}) {
  return (
    <Card
      variant="outlined"
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        borderRadius: 3,
        overflow: "hidden",
        border: `1px solid ${alpha(accentColor, 0.2)}`,
        borderLeft: `4px solid ${accentColor}`,
        background: `linear-gradient(180deg, ${alpha(accentColor, 0.08)} 0%, #fff 30%)`,
        boxShadow: `0 6px 18px ${alpha(accentColor, 0.1)}`,
        transition: "box-shadow 140ms ease",
        "&:hover": {
          boxShadow: `0 10px 24px ${alpha(accentColor, 0.14)}`,
        },
      }}
    >
      <CardContent sx={{ flex: 1, pb: 1.25, minWidth: 0 }}>
        <Stack spacing={1.25} sx={{ minWidth: 0 }}>
          {chips}

          <Typography
            variant="h6"
            sx={{ lineHeight: 1.25, fontWeight: 700, overflowWrap: "anywhere" }}
          >
            {title}
          </Typography>

          <Stack spacing={0.65} sx={{ color: "text.secondary", minWidth: 0 }}>
            {info}
          </Stack>

          {body}
        </Stack>
      </CardContent>

      <Divider sx={{ borderColor: alpha(accentColor, 0.2) }} />

      <CardActions
        sx={{
          p: 1.25,
          pt: 1,
          bgcolor: alpha(accentColor, 0.03),
        }}
      >
        <Stack spacing={1} width="100%" sx={{ minWidth: 0 }}>
          {primaryAction}

          {showManagement ? (
            <>
              <Divider>
                <Typography variant="caption" sx={{ color: "text.secondary", px: 0.5, fontWeight: 600 }}>
                  Verwaltung
                </Typography>
              </Divider>
              <Stack spacing={0.75} sx={{ minWidth: 0 }}>{managementActions}</Stack>
            </>
          ) : null}
        </Stack>
      </CardActions>
    </Card>
  );
}

BaseEventCard.propTypes = {
  accentColor: PropTypes.string.isRequired,
  title: PropTypes.string,
  chips: PropTypes.node,
  info: PropTypes.node,
  body: PropTypes.node,
  primaryAction: PropTypes.node,
  managementActions: PropTypes.node,
  showManagement: PropTypes.bool,
};

BaseEventCard.defaultProps = {
  title: "Unbenannte Veranstaltung",
  chips: null,
  info: null,
  body: null,
  primaryAction: null,
  managementActions: null,
  showManagement: false,
};
